import {View as TVSafeAreaView} from '@/components/Theme';
export const SafeAreaView = (props) => <TVSafeAreaView noSwitch {...props} />;